<template>
  <div v-title="$route.name">
    <div class="page-heading">
      <h3>{{ $route.name }}</h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row>
        <el-table-column prop="id"
                         label="ID"></el-table-column>

        <el-table-column prop="userid"
                         label="管理员ID"></el-table-column>

        <el-table-column prop="username"
                         label="管理员"></el-table-column>

        <el-table-column prop="opname"
                         label="管理员行为"></el-table-column>

        <el-table-column prop="created_at"
                         label="时间"></el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>


<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      // 表格数据
      table: [],
    }
  },
  created () {},
  methods: {
    getTableData (params) {
      return request.page('AuditLogTableApi', params)
    },
  },
}
</script>

<style lang="scss"
       scoped
       src="../style/PlatformUser.scss"></style>



// WEBPACK FOOTER //
// src/views/platform-user/pages/AuditLogTable.vue